var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45703 6.70898C4.32031 6.57227 4.10156 6.57227 3.99219 6.70898L3.36328 7.31055C3.22656 7.44727 3.22656 7.66602 3.36328 7.77539L5.85156 10.291C5.96094 10.4277 6.17969 10.4277 6.31641 10.291L11.0195 5.61523C11.1562 5.47852 11.1562 5.25977 11.0195 5.15039L10.418 4.52148C10.2812 4.38477 10.0898 4.38477 9.95312 4.52148L6.09766 8.34961L4.45703 6.70898ZM12.7422 2.68945L7.49219 0.501953C7.32812 0.447266 7.16406 0.419922 7 0.419922C6.80859 0.419922 6.64453 0.447266 6.48047 0.501953L1.23047 2.68945C0.738281 2.9082 0.4375 3.37305 0.4375 3.89258C0.4375 9.33398 3.55469 13.0801 6.48047 14.3105C6.80859 14.4473 7.16406 14.4473 7.49219 14.3105C9.84375 13.3262 13.5625 9.96289 13.5625 3.89258C13.5625 3.37305 13.2344 2.9082 12.7422 2.68945ZM7 13.0801C4.32031 11.9863 1.75 8.54102 1.75 3.89258L7 1.70508L12.25 3.89258C12.25 8.65039 9.54297 12.0137 7 13.0801Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.d098e8d9.svg";
export { ForwardRef as ReactComponent };